import { backToTop } from "./modules/back-to-top";
import { eventTracking } from "./modules/eventTracking";
import { featuredPicksSlider } from "./modules/featuredPicksSlider";
import { modal } from "./modules/modal";
import { rfqWidget } from "./modules/rfq-widget";
import { smoothScroll } from "./modules/smoothScroll";
import { topPicksSlider } from "./modules/topPicksSlider";

window.addEventListener("DOMContentLoaded", () => {
  backToTop().init();
  eventTracking().init();
  featuredPicksSlider().init();
  modal().init();
  rfqWidget().init();
  smoothScroll().init();
  topPicksSlider().init();
});
